import type { RootState } from '@/store/root-reducer';

const selectDiscoveredLpDetail = (state: RootState) => state.discoveredLpDetail;

export const selectListId = (state: RootState) => selectDiscoveredLpDetail(state).listId;
export const selectList = (state: RootState) => selectDiscoveredLpDetail(state).list;
export const selectCommentCount = (state: RootState) =>
  selectDiscoveredLpDetail(state).commentCount;
export const selectLoadStatus = (state: RootState) => selectDiscoveredLpDetail(state).loadStatus;
export const selectError = (state: RootState) => selectDiscoveredLpDetail(state).error;

export const selectRows = (state: RootState) => selectDiscoveredLpDetail(state).rows;
export const selectTotal = (state: RootState) => selectDiscoveredLpDetail(state).total;
export const selectRowsLoading = (state: RootState) => selectDiscoveredLpDetail(state).rowsLoading;
export const selectRowsError = (state: RootState) => selectDiscoveredLpDetail(state).rowsError;
export const selectPage = (state: RootState) => selectDiscoveredLpDetail(state).page;
export const selectPageSize = (state: RootState) => selectDiscoveredLpDetail(state).pageSize;
export const selectFilters = (state: RootState) => selectDiscoveredLpDetail(state).filters;
export const selectSearch = (state: RootState) => selectDiscoveredLpDetail(state).search;
export const selectAiSearch = (state: RootState) => selectDiscoveredLpDetail(state).aiSearch;
export const selectCategoryCounts = (state: RootState) =>
  selectDiscoveredLpDetail(state).categoryCounts;
export const selectFacetOptions = (state: RootState) =>
  selectDiscoveredLpDetail(state).facetOptions;
